import { createStore } from '@stencil/store';

const initialState = {
  firstName: null,
  lastName: null,
  email: null,
  confirmEmail: null,
  legalAcceptance: false,
  phone: null,
  zip: null,
  showReplacementVehicleSection: true,
  emailCustomerCheckbox: 1,
  showLegalAcceptance: true,
};

const { on, onChange, state, reset } = createStore(initialState);

export { initialState, on, onChange, state, reset };
export default state;
